module.exports = Object.freeze({
    PM: 'PM',
    PMO: 'PMO',
    FINANCE_MANAGER: 'Finance Manager',
    RP: 'RP',
    SYSTEM_ADMIN: 'System Admin',
    DEPARTMENT_HEAD: 'Department Head',
    PRACTICE_HEAD: 'Practice Head'  
  });
  